import React, { useState, useEffect } from 'react';
import { FileTextOutlined } from '@ant-design/icons';
import * as pdfjs from 'pdfjs-dist';
import assetService from '../../services/assetService';

// 设置 PDF.js worker - 使用统一的worker配置
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// Helper component to render PDF thumbnail
const PDFThumbnail = ({ url, className = '' }) => {
  const [thumbnailDataURL, setThumbnailDataURL] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const generateThumbnail = async () => {
      if (!url) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        console.log('Loading PDF from URL:', url);

        // 使用assetService获取PDF数据
        const pdfData = await assetService.fetchPdfData(url);

        // Load PDF document with error handling
        const loadingTask = pdfjs.getDocument({
          data: pdfData,
          // 禁用字体加载以避免CORS问题
          disableFontFace: true,
          // 设置更大的超时时间
          docBaseUrl: '',
          // 添加更多配置来提高兼容性
          useSystemFonts: true,
          verbosity: 0, // 减少控制台输出
        });
        const pdf = await loadingTask.promise;

        // Get first page
        const page = await pdf.getPage(1);

        // Create canvas for thumbnail
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        // Set thumbnail size (small preview) - 调整缩放比例
        const viewport = page.getViewport({ scale: 0.3 });
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        // Render page to canvas
        await page.render({
          canvasContext: context,
          viewport: viewport,
        }).promise;

        // Convert canvas to data URL
        const dataURL = canvas.toDataURL('image/png', 0.8);
        setThumbnailDataURL(dataURL);
        console.log('PDF thumbnail generated successfully for:', url);
      } catch (error) {
        console.error('Failed to generate PDF thumbnail:', error);
        setError(error.message || 'PDF缩略图生成失败');
      } finally {
        setLoading(false);
      }
    };

    generateThumbnail();
  }, [url]);

  if (loading) {
    return (
      <div
        className={`w-full h-full flex items-center justify-center bg-gray-100 ${className}`}
      >
        <FileTextOutlined className="text-2xl text-gray-400" />
      </div>
    );
  }

  if (error || !thumbnailDataURL) {
    return (
      <div
        className={`w-full h-full flex items-center justify-center bg-gray-100 ${className}`}
      >
        <FileTextOutlined className="text-2xl text-gray-400" />
      </div>
    );
  }

  return (
    <img
      src={thumbnailDataURL}
      alt="PDF Preview"
      className={`w-full h-full object-cover ${className}`}
    />
  );
};

export default PDFThumbnail;
